import { NgModule } from '@angular/core';

import { ApAuthenticatieFidoResource } from './authenticatie-fido.resource';

/**
 * @ngdoc module
 * @name ApAuthenticatieFidoModule
 * @description interface to apic-authenticatie-fido
 **/
@NgModule({
    providers: [ApAuthenticatieFidoResource]
})
export class ApAuthenticatieFidoModule {}
